const CameraIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.78105 10.1145C4.28095 10.6146 4 11.2929 4 12.0002V24.0002C4 24.7074 4.28095 25.3857 4.78105 25.8858C5.28115 26.3859 5.95942 26.6668 6.66667 26.6668H25.3333C26.0406 26.6668 26.7189 26.3859 27.219 25.8858C27.719 25.3857 28 24.7074 28 24.0002V12.0002C28 11.2929 27.719 10.6146 27.219 10.1145C26.7189 9.61445 26.0406 9.3335 25.3333 9.3335H24.0933C23.6544 9.33356 23.2223 9.22529 22.8352 9.01828C22.4482 8.81128 22.1183 8.51194 21.8747 8.14683L20.792 6.52016C20.5484 6.15505 20.2185 5.85572 19.8314 5.64871C19.4444 5.4417 19.0122 5.33343 18.5733 5.3335H13.4267C12.9878 5.33343 12.5556 5.4417 12.1686 5.64871C11.7815 5.85572 11.4516 6.15505 11.208 6.52016L10.1253 8.14683C9.88174 8.51194 9.55179 8.81128 9.16475 9.01828C8.77772 9.22529 8.34558 9.33356 7.90667 9.3335H6.66667C5.95942 9.3335 5.28115 9.61445 4.78105 10.1145Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M18.8284 20.1619C19.5786 19.4118 20 18.3944 20 17.3335C20 16.2726 19.5786 15.2552 18.8284 14.5051C18.0783 13.7549 17.0609 13.3335 16 13.3335C14.9391 13.3335 13.9217 13.7549 13.1716 14.5051C12.4214 15.2552 12 16.2726 12 17.3335C12 18.3944 12.4214 19.4118 13.1716 20.1619C13.9217 20.9121 14.9391 21.3335 16 21.3335C17.0609 21.3335 18.0783 20.9121 18.8284 20.1619Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);

export default CameraIcon;
